// extracted by mini-css-extract-plugin
module.exports = {"add":"ViewUserLotsContainer_add__TeAmN","tabs":"ViewUserLotsContainer_tabs__3GPSa"};